import { useState, useRef, useEffect } from "react";

export default function AddVendorModal({ existingVendors, onCreate, onCancel }) {
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef();

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, []);

  const trimmed = name.trim();
  const isDuplicate = existingVendors.some(
    (v) => v.name.toLowerCase() === trimmed.toLowerCase()
  );
  const hasInvalidChars = /[\\/:*?"<>|]/.test(trimmed);

  const canSubmit = trimmed.length > 0 && !isDuplicate && !hasInvalidChars && !creating;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setCreating(true);
    setError(null);
    try {
      await onCreate(trimmed);
      onCancel(); // close on success
    } catch (e) {
      setError(e.message || "Failed to create vendor folder");
      setCreating(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Add a vendor</h3>
        <p>This will create a new folder in SharePoint for the vendor.</p>

        <input
          ref={inputRef}
          type="text"
          placeholder="e.g. Acme Supply Co."
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleSubmit(); }}
          style={{
            width: "100%",
            padding: "10px 12px",
            fontSize: "14px",
            fontFamily: "var(--font)",
            border: "1px solid var(--border-md)",
            borderRadius: "var(--radius)",
            background: "var(--surface)",
            color: "var(--text)",
            outline: "none",
            marginBottom: "8px",
          }}
        />

        {isDuplicate && (
          <p style={{ fontSize: 12, color: "#C94B2A", marginBottom: 8 }}>
            A vendor folder with this name already exists.
          </p>
        )}
        {hasInvalidChars && (
          <p style={{ fontSize: 12, color: "#C94B2A", marginBottom: 8 }}>
            Name can't contain: \ / : * ? " &lt; &gt; |
          </p>
        )}
        {error && (
          <p style={{ fontSize: 12, color: "#C94B2A", marginBottom: 8 }}>{error}</p>
        )}

        <div className="modal-actions">
          <button className="btn" onClick={onCancel} disabled={creating}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={!canSubmit}
            onClick={handleSubmit}
          >
            {creating ? "Creating…" : "Create vendor"}
          </button>
        </div>
      </div>
    </div>
  );
}
